import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
import {GetOvertimePolicyGroupConfig} from "./PayrollPolicyApi";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PayrollPolicySlice = createSlice({
    name: 'payrollPolicyService',
    initialState: {
        getOvertimePolicyGroupConfig: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetOvertimePolicyGroupConfig.fulfilled, (state, { payload }) => {
                state.getOvertimePolicyGroupConfig = ResponseApi(payload);
            })

    },
});

export default PayrollPolicySlice.reducer;
